(function (mod) {
	if (typeof exports === "object") {
		module.exports = mod();
	}else{
		window.Mo = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ Load Class ↓
/////////////////////////////////////////////////////////////////////////
var L=function(C){
	this.complete=false;
    
	//$(".container").css({visibility:"visible",opacity:0.0,display:"none"});
	//$("#menu").css({visibility:"visible"});
    //$("#menu").fadeOut(0);
	//$("html").css({overflow:"hidden"})
		
	//$("body").append('<div id="loading"><div id="progress">0%<div></div>');
	//this.dom= new createjs.DOMElement("loading");
	//C.stage.addChild(this.dom);
	
}
L.prototype.open=function(C){
	//$("#loading").css({visibility:"visible",opacity:1.0});
}

L.prototype.progress=function(e){
	//ゲージ増加
	//var p=Math.floor(e.progress*100)+"%";
	//$("#progress").animate({width:p},100);
}

L.prototype.close=function(p){
    var sp=p||1000;
	var dfd = $.Deferred();
	//ロードけす
    /*
	$("#loading").fadeOut(sp,"swing",function(){
		dfd.resolve();
		$("html").css({overflow:"visible"})
	});
    */
	//this.fOut(this.t);
	//this.fOut(this.dom);
	//$("html").css({overflow:"visible"})
	return dfd.promise();
}


L.prototype.fOut=function(cjsobj){
	Q.info("fade out!!");
	createjs.Ticker.addEventListener("tick",{
		handleEvent:function(){
			cjsobj.alpha*=0.8;
			if(cjsobj.alpha<0.05){
				cjsobj.alpha=0.0;
				cjsobj.visible=false;
				Q.info("fadeOut end!!");
				createjs.Ticker.removeEventListener("tick",this);
			}
		}	
	});
}


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return L;
/////////////////////////////////////////////////////////////////////////

})();
return Mo;
});


